/**
 * 将常规base64字符串转化为 URL safe without padding
 *
 * @param {string} base64
 * @returns {string}
 */
export function toUrlSafeBase64(base64) {
    return base64
        .replace(/\+/g, '-') // Convert '+' to '-'
        .replace(/\//g, '_') // Convert '/' to '_'
        .replace(/=+$/, ''); // Remove ending '='
}


/**
 * 从urlSafe方式的base64字符串还原回常规base64
 *
 * @param {string}  base64UrlSafe
 * @returns {string}
 */
export function toNormalBase64(base64UrlSafe) {
    // Add removed at end '='
    base64UrlSafe += Array((5 - base64UrlSafe.length % 4) % 4).join('=');
    return base64UrlSafe
        .replace(/\-/g, '+') // Convert '-' to '+'
        .replace(/\_/g, '/'); // Convert '_' to '/'
}

/**
 * 把Base64字符串转化成PEM格式字符串，用于封装秘钥
 *
 * @param {string} cleanedBase64
 * @param {string} header
 * @returns {string}
 */
export function convertBase64toPEM(cleanedBase64, header) {
    // var cleanedBase64 = cleanBase64(document.frmConvert.edInput.value);
    // document.frmConvert.cleanedBase64.value = cleanedBase64;

    let wrapped = cleanedBase64.replace(/(\S{64}(?!$))/g, "$1\r\n");
    // var header = document.frmConvert.headerType.value;
    if (header != "- none -") {
        wrapped = "-----BEGIN " + header + "-----\r\n"
            + wrapped
            + "\r\n-----END " + header + "-----\r\n";
    }
    return wrapped
    // document.frmConvert.edOutput.value = wrapped;
}

// module.exports = {toUrlSafeBase64, toNormalBase64, convertBase64toPEM}